export const getGraphErrorMessage = (resultOrError, fallback = 'Request failed') => {
  const message = resultOrError?.errors?.[0]?.message || resultOrError?.message;
  return message || fallback;
};

export const sortByName = (items = []) => [...items].sort((a, b) => a.name.localeCompare(b.name));

export const hasGraphErrors = (result) => !result || (Array.isArray(result.errors) && result.errors.length > 0);

export const getBusinessUnitsLabelText = (t) => t('Informative.Labels.businessUnits').replace(':', '');
